var map = {
	"./Clippath.png": 6091,
	"./Copilotlogo.png": 6899,
	"./Data-protection.png": 3686,
	"./DataProtection.png": 2641,
	"./Default-learncard-img.png": 8836,
	"./LinkedIn.png": 7394,
	"./MicrosoftLogo.png": 2183,
	"./bot.png": 9093,
	"./cta.png": 8452,
	"./discussionDefaultImg.jpg": 640,
	"./discussionDefaultImg_1.jpg": 8560,
	"./ey.png": 6958,
	"./kokoroe.png": 6600,
	"./mslogo.png": 893,
	"./people.png": 981,
	"./skillpeople.png": 3744,
	"./skills.png": 5442,
	"./story1.png": 8820,
	"./story2.png": 447,
	"./story3.png": 6646,
	"./topic.png": 6467,
	"./yt.png": 4431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;